// extracted by mini-css-extract-plugin
export default {"root":"RightMenu_root__dmtAh","item":"RightMenu_item__rOVZ1","icons":"RightMenu_icons__A30mO"};